/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:38
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace CspInquiry {
    /**
    * 获取csp询价列表
    */
    export var GetCspInquiryList = (query: any): Promise<any> => {
        return Get(`/csp/CspInquiry/GetCspInquiryList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取总(待发布)询价详情
    */
    export var GetCspInquiry = (cspInquiryId): Promise<any> => {
        return Get(`/csp/CspInquiry/GetCspInquiry/${cspInquiryId}`, { cspInquiryId: cspInquiryId });
    };
    /**
    * 获取子询价详情
    */
    export var GetCspInquiryChild = (id): Promise<type.CspInquiryChildDetailVM> => {
        return Get(`/csp/CspInquiry/GetCspInquiryChild/${id}`, {});
    };
    /**
     * 添加发布询价
     */
    export var AddCspInquiry = (body: type.AddCspInquiryItem): Promise<any> => {
        return Post(`/csp/CspInquiry/AddCspInquiry`, body);
    };
    /**
     * 编辑待发布询价单(总)
     */
    export var UpdateCspInquriy = (body: any): Promise<any> => {
        return Post(`/csp/CspInquiry/UpdateCspInquriy`, body);
    };
    /**
 * 编辑待接单询价信息(子)
 */
    export var UpdateCspInquiryChild = (body: any): Promise<any> => {
        return Post(`/csp/CspInquiry/UpdateCspInquiryChild`, body);
    };

    /**
     * 删除询价(总或者子)
     */
    export var DeleteCspInquiry = (body: any): Promise<any> => {
        return Put(`/csp/CspInquiry/DeleteCspInquiry`, body);
    };
    /**
 * 终结发布询价
 */
    export var EditCspInquiry = (id: string): Promise<any> => {
        return Put(`/csp/CspInquiry/EditCspInquiry/${id}`, {});
    };
    /**
     * 地址识别
     */
    export var GetAddressCode = (query: any): Promise<any> => {
        return Get(`/csp/CspInquiry/GetAddressCode`, { text: query });
    };
    /**
     * 获取客户代表列表
     */
    export var customerRepresentative = (query: any): Promise<any> => {
        return Get(`/csp/CustomerRepresentative?${qs.stringify(query)}`, {});
    };
    /**
     * 装车要素
     */
    export var getLoadType = (query: any): Promise<any> => {
        return Get(`/csp/SystemAttribute/GetList?${qs.stringify(query)}`, {});
    };
    /**
     * 月度询价统计
     */
    export var QtyStatistics = (query: any): Promise<any> => {
        return Get(`/csp/CspInquiry/QtyStatistics?${qs.stringify(query)}`, {});
    };
    /**
     * 货物列表
     */
    export var getGoodsList = (query: any): Promise<any> => {
        return Get(`/csp/Goods/getGoodsList?${qs.stringify(query)}`, {});
    };

}
